<template lang="pug">
v-app
  v-container(grid-list-xl, fluid)
    v-layout(row, wrap)
      v-flex(lg12)
        form(@submit.prevent="validate")
          v-card.elevation-1
            v-card-text
              v-layout(row, wrap)
                v-flex.md6.xs12
                  v-text-field(label='Nome', color="gray", :readonly='true', required, v-validate="'required'", :error-messages="errors.collect('nome')", data-vv-name="nome", type="text", v-model='usuario.nome')
              v-layout(row, wrap)
                v-flex.md6.xs12
                  v-text-field(label='E-mail', color="gray", :readonly='true', required, v-validate="'required|email'", :error-messages="errors.collect('email')", data-vv-name="email", type="email", v-model='usuario.email')
              v-layout(row, wrap)
                v-flex.md6.xs12
                  span.subheading Alterar Senha 
                  v-btn(icon, @click="show = !show") 
                    v-icon {{ show ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
              v-layout(row, wrap)
                v-slide-y-transition
                  v-flex.md6.xs12(v-if="show")
                    v-text-field(label='Senha Atual', required, v-validate="'required'", :error-messages="errors.collect('senha_atual')", data-vv-as="senha atual", data-vv-name="senha_atual", type="password", v-model='usuario.senha_atual')
                    v-text-field(label='Nova Senha', required, v-validate="'required'", :error-messages="errors.collect('senha_nova')", data-vv-as="nova senha", data-vv-name="senha_nova", ref="senha_nova", type="password", v-model='usuario.senha_nova')
                    v-text-field(label='Repita', required, v-validate="'required|confirmed:senha_nova'", :error-messages="errors.collect('conf_senha')", data-vv-as="repita", data-vv-name="conf_senha", type="password", v-model='usuario.conf_senha')
              v-layout(row, wrap)
                v-flex.xs12
                  v-btn.ma-0(color='accent', type="submit", :loading='loading') Salvar
</template>

<script>
import _ from 'lodash';
import Hashes from 'jshashes';
// eslint-disable-next-line
const SHA512 = new Hashes.SHA512;

export default {
  $_veeValidate: {
    validator: 'new'
  },
  data: () => ({
    show: true,
    loading: false,
    usuario: {},
  }),
  mounted () {
    const vm = this;
    vm.usuario = _.cloneDeep(vm.$root.user);
  },
  methods: {
    async updateUser (user) {
      const vm = this;
      try {
        const response = await vm.$axios.put('/usuario', { _id: user._id, nome: user.nome, email: user.email });
        vm.$store.dispatch('setUser', _.merge(user, response.data));
        vm.loading = false;
        window.getApp.$emit('APP_ALERT', { color: 'success', text: 'Usuário salvo com sucesso!' });
      } catch (error) {
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao salvar o usuário. Tente novamente!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
        vm.loading = false;
      }
    },
    async updatePassword (user) {
      const vm = this;
      try {
        let usuario = _.cloneDeep(user);
        usuario.senhaAtual = SHA512.hex(usuario.senha_atual);
        usuario.senhaNova = SHA512.hex(usuario.senha_nova);
        const response = await vm.$axios.put('/password/update', usuario);
        for (let prop in usuario) if (prop.indexOf('senha') > -1) delete usuario[prop];
        for (let prop in user) if (prop.indexOf('senha') > -1) delete user[prop];
        vm.$store.dispatch('setUser', _.merge(usuario, response.data));
        vm.loading = false;
        window.getApp.$emit('APP_ALERT', { color: 'success', text: 'Senha atualizada com sucesso!' });
      } catch (error) {
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao salvar atualizar a senha. Tente novamente!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
        vm.loading = false;
      }
    },
    async validate () {
      const vm = this;
      try {
        vm.loading = true;
        const result = await vm.$validator.validateAll();
        if (!result) throw "Preencha todos os campos corretamente!";
        if (vm.show) vm.updatePassword(vm.usuario);
        else vm.updateUser(vm.usuario);
        vm.$validator.reset();
      } catch (error) {
        window.getApp.$emit("APP_ALERT", { color: "red", text: error });
        vm.loading = false;
      }
    },
  }
};
</script>

<style scoped lang="css">

</style>
